import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, Overline } from "@/components/Reveal";

export default function Brands() {
  return (
    <div data-testid="brands-page">
      <PageHero
        overline="Our Brands"
        title={<>Partnered with the <span className="text-gold-gradient italic">Finest.</span></>}
        subtitle="We work with trusted, premium brands to bring you products of uncompromising quality across plywood, laminates, hardware and smart locks."
        image="/photos/brand/choose1.jpeg"
      />

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <Reveal>
            <Overline>Trusted Partner Brands</Overline>
            <p className="mt-5 max-w-2xl text-[#b8b8b8] leading-relaxed">
              Our showroom features leading names across plywood, laminates, hardware and smart locks — curated for quality and reliability. To know the exact brands we stock for your project, get in touch with our team.
            </p>
            <Link to="/contact" data-testid="brands-enquire-btn" className="mt-8 inline-flex items-center gap-2 border border-[#e7c15a] px-7 py-3.5 text-xs uppercase tracking-[0.2em] text-[#e7c15a] hover:bg-[#e7c15a] hover:text-[#050505] transition-colors">
              Ask About Our Brands <ArrowRight size={14} />
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <Reveal className="border border-[#e7c15a]/25 bg-gradient-to-br from-[#0d0b06] to-[#050505] p-10 md:p-16 text-center">
            <h2 className="font-serif-lux text-3xl md:text-5xl tracking-tight">Are you a brand or distributor?</h2>
            <p className="mt-5 text-[#b8b8b8] max-w-xl mx-auto">We&apos;re always open to partnering with premium interior brands. Reach out to explore a collaboration.</p>
            <Link to="/contact" className="mt-8 inline-flex items-center gap-2 bg-[#e7c15a] px-9 py-4 text-xs uppercase tracking-[0.2em] font-medium text-[#050505]">Partner With Us <ArrowRight size={15} /></Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
